// extracted by mini-css-extract-plugin
module.exports = {"template_input":"Template__template_input___1OSZ6","variable":"Template__variable___BHrHx","close_img":"Template__close_img___1naHi"};